import { render, staticRenderFns } from "./banner-countdown.vue?vue&type=template&id=c4985d6e&scoped=true&"
import script from "./banner-countdown.vue?vue&type=script&lang=js&"
export * from "./banner-countdown.vue?vue&type=script&lang=js&"
import style0 from "./banner-countdown.vue?vue&type=style&index=0&id=c4985d6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4985d6e",
  null
  
)

export default component.exports